import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import apiClient from "../Login/apiClient";

const Container = styled.div`
  max-width: 700px;
  margin: 30px auto;
  padding: 0 16px;

  @media (max-width: 768px) {
    margin: 16px auto;
    padding: 0 8px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const FilterRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 6px;
  }
`;

const FilterSelect = styled.select`
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  background: #fff;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const GoalCard = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

const GoalInfo = styled.div`
  flex: 1;
`;

const GoalTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  word-break: break-word;
`;

const GoalMeta = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 4px;
`;

const GoalDeadline = styled.div`
  font-size: 13px;
  color: #999;
  text-align: right;
  min-width: 100px;
`;

const CATEGORY_MAP = {
  sports: "\u30b9\u30dd\u30fc\u30c4",
  company: "\u4f1a\u793e",
  entrepreneurship: "\u8d77\u696d",
  career: "\u8077\u696d\u30fb\u30ad\u30e3\u30ea\u30a2",
  romance: "\u604b\u611b",
  study: "\u8cc7\u683c\u30fb\u52c9\u5f37",
  self_satisfaction: "\u81ea\u5df1\u6e80\u8db3",
  literature: "\u6f2b\u753b\u3001\u6587\u5b66",
};

function GoalList() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [goals, setGoals] = useState([]);
  const [sortBy, setSortBy] = useState("-created_at");
  const [filterCategory, setFilterCategory] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGoals = async () => {
      try {
        const tokens = JSON.parse(localStorage.getItem("ResponseData"));
        const token = tokens.access;
        const response = await apiClient.get(`${API_BASE_URL}/api/goals/`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { ordering: sortBy },
        });
        setGoals(response.data);
      } catch (error) {
        toast.error("\u76ee\u6a19\u306e\u53d6\u5f97\u306b\u5931\u6557\u3057\u307e\u3057\u305f\u3002");
      }
    };

    fetchGoals();
  }, [API_BASE_URL, sortBy]);

  const filteredGoals = filterCategory ? goals.filter((goal) => goal.category === filterCategory) : goals;

  return (
    <Container>
      <Title>My Goals</Title>

      <FilterRow>
        <FilterSelect value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="-created_at">\u65b0\u3057\u3044\u9806</option>
          <option value="created_at">\u53e4\u3044\u9806</option>
          <option value="-support_count">\u5fdc\u63f4\u304c\u591a\u3044\u9806</option>
          <option value="-no_way_count">\u3067\u304d\u308b\u308f\u3051\u306a\u3044\u3088\u304c\u591a\u3044\u9806</option>
        </FilterSelect>

        <FilterSelect value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
          <option value="">\u5168\u30ab\u30c6\u30b4\u30ea</option>
          {Object.entries(CATEGORY_MAP).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </FilterSelect>
      </FilterRow>

      {filteredGoals.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
          \u76ee\u6a19\u304c\u3042\u308a\u307e\u305b\u3093
        </div>
      ) : (
        filteredGoals.map((goal) => (
          <GoalCard key={goal.id} onClick={() => navigate(`/boards/${goal.id}`)}>
            <GoalInfo>
              <GoalTitle>{goal.title}</GoalTitle>
              <GoalMeta>
                {CATEGORY_MAP[goal.category] || goal.category}
                {" | "}
                \u5fdc\u63f4 {goal.support_count} / \u7121\u7406 {goal.no_way_count}
              </GoalMeta>
            </GoalInfo>
            <GoalDeadline>{goal.deadline}</GoalDeadline>
          </GoalCard>
        ))
      )}
      <ToastContainer position="top-center" autoClose={3000} />
    </Container>
  );
}

export default GoalList;
